import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const LanguageContext = createContext(null);

const dictionary = {
  en: {
    navigation: {
      home: 'Home',
      residences: 'Residences',
      sale: 'Sale',
      location: 'Sveti Stefan',
      book: 'Book direct',
      contact: 'Contact',
    },
    common: {
      book: 'Book your stay',
      discover: 'Discover the residences',
      learnMore: 'View residence',
      back: 'All residences',
      directBooking: 'Direct booking',
    },
  },
  ru: {
    navigation: {
      home: 'Главная',
      residences: 'Апартаменты',
      sale: 'Продажа',
      location: 'Святой‑Стефан',
      book: 'Забронировать',
      contact: 'Контакты',
    },
    common: {
      book: 'Забронировать проживание',
      discover: 'Смотреть апартаменты',
      learnMore: 'О резиденции',
      back: 'Все апартаменты',
      directBooking: 'Прямое бронирование',
    },
  },
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    try {
      const stored = window.localStorage.getItem('amr-language');
      return stored === 'ru' ? 'ru' : 'en';
    } catch {
      return 'en';
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem('amr-language', language);
    } catch {
      // The site remains usable when a browser blocks local storage.
    }
    document.documentElement.lang = language;
  }, [language]);

  const value = useMemo(() => {
    const t = (path) => {
      return path.split('.').reduce((current, key) => current?.[key], dictionary[language]) || path;
    };

    return { language, setLanguage, t };
  }, [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider.');
  }

  return context;
}
